import { humanReadableField } from '~/filters/humanReadableField';
import { packagingId } from '~/helpers/fields-description';
import { LegrandModule } from './LegrandModule.model';

export class NLLF extends LegrandModule {
    get fieldPackaging() {
        if (this.packaging) {
            return packagingId(humanReadableField(this.packaging));
        }
    }
}
